import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { usePutAway } from '../../shared';
import './sticky-note.scss';
export default function StickyNote({ bannerData }) {
    const [closed, PutAway] = usePutAway();
    if (!bannerData || closed || bannerData.mode !== 'emergency') {
        return null;
    }
    return (React.createElement("div", { className: "sticky-note", "data-analytics-view": true, "data-analytics-nudge": "emergency", "data-nudge-placement": "banner" },
        React.createElement("div", { className: "text-content", role: "alert" },
            React.createElement(PutAway, null),
            React.createElement(RawHTML, { className: "html-content", html: bannerData.emergency_content }))));
}
